module.exports = __webpack_public_path__ + "assets/images/disney_plus_logo.638daef3b2c617f177b3ecd6abcaadc6.png";